import { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { applyMeta, NOT_FOUND_META } from '@/lib/seo'

export default function NotFound() {
  const { pathname } = useLocation()

  useEffect(() => {
    applyMeta(NOT_FOUND_META, pathname)
  }, [pathname])

  return (
    <main id="top">
      <section className="post-head">
        <div className="wrap-wide">
          <span className="eyebrow">Error 404</span>
          <h1>Page not found</h1>
          <p style={{ color: 'var(--muted)', marginTop: '14px', maxWidth: '60ch' }}>
            The page you are looking for doesn't exist or has moved.
          </p>
          <div className="hero-actions" style={{ marginTop: '28px' }}>
            <Link className="btn btn-primary" to="/">
              Back to Home <span className="arw">→</span>
            </Link>
            <Link className="btn btn-ghost" to="/services/">
              View Services
            </Link>
          </div>
        </div>
      </section>
    </main>
  )
}
